module.exports = __webpack_public_path__ + "img/workTasks.82e2c36a.svg";